export default {
  empty: '暫無已選產品',
};
